"use strict";var e=require("@apollo/client").gql`
  mutation DeleteCard($deleteCardInput: DeleteCardInput!) {
    deleteCard(deleteCardInput: $deleteCardInput) {
      success
    }
  }
`;exports.d=e;